import { KILO, MEGA } from 'constants/metricPrefixes'
import { div } from 'shared/helpers/number'

import { TOrderCargo, TOrderCargoTotal } from '../types'

/** Форматирует высоту, ширину, длину для отображения пользователю в см */
export const formatCargoSize = (
  length?: number,
  width?: number,
  height?: number,
  isNeedSpace: boolean | undefined = true
): string => {
  const SPACE = isNeedSpace ? ' ' : ''

  if ((length && width && height) || (length === 0 && width === 0 && height === 0)) {
    return `${length}${SPACE}×${SPACE}${width}${SPACE}×${SPACE}${height} см`
  }

  return ''
}

export const formatCargoSizeSeparate = ({ length, width, height } = {} as unknown as TOrderCargo): string =>
  formatCargoSize(length, width, height)

export const formatCargoSizeTotal = ({ length, width, height } = {} as unknown as TOrderCargoTotal): string =>
  formatCargoSize(length, width, height)

/** Форматирует вес для отображения пользователю (кг) */
export const formatCargoWeight = (weight?: string | number, fallbackValue?: string): string => {
  if (weight === undefined) {
    return fallbackValue || ''
  }

  if (Number(weight) === 0) {
    return '0 кг'
  }

  return `${String(weight).replace('.', ',')} кг`
}

/** Форматирует и вычисляет вес для отображения пользователю (из гр в кг) */
export const formatCargoWeightGramToKilogram = (weight?: string | number, fallbackValue?: string): string => {
  if (weight === undefined) {
    return fallbackValue || ''
  }

  return formatCargoWeight(div(weight, KILO, 6), fallbackValue)
}

/** Форматирует объём для отображения пользователю (м³) */
export const formatCargoVolume = (volume?: string | number, fallbackValue?: string) => {
  if (volume === undefined) {
    return fallbackValue || ''
  }

  if (Number(volume) === 0) {
    return '0 м³'
  }

  return `${String(volume).replace('.', ',')} м³`
}

/** Форматирует и вычисляет объём для отображения пользователю (из см³ в м³) */
export const formatCargoVolumeCentimeter3ToMeter3 = (volume?: string | number, fallbackValue?: string) => {
  if (volume === undefined) {
    return fallbackValue || ''
  }

  return formatCargoVolume(div(volume, MEGA, 6), fallbackValue)
}
